import React from 'react';
import { Navigate } from 'react-router-dom';

const Home: React.FC = () => <Navigate to={'/board-orders'} />;

export default Home;
